// Centralized image library, DARK premium imagery for Innovher

export const IMG = {
  // Hero / Founder, dramatic dark portraits
  founderPortrait: 'https://images.unsplash.com/photo-1665224752123-a2ea29dddcb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxkYXJrJTIwcG9ydHJhaXQlMjBidXNpbmVzcyUyMHdvbWFufGVufDB8fHx8MTc3OTk2MTQ0Mnww&ixlib=rb-4.1.0&q=85&w=900',
  founderAlt: 'https://images.unsplash.com/photo-1665224751641-8ea911ca2267?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxkYXJrJTIwcG9ydHJhaXQlMjBidXNpbmVzcyUyMHdvbWFufGVufDB8fHx8MTc3OTk2MTQ0Mnww&ixlib=rb-4.1.0&q=85&w=900',
  founderAlt2: 'https://images.unsplash.com/photo-1665224752136-4dbe2dfc8195?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkYXJrJTIwcG9ydHJhaXQlMjBidXNpbmVzcyUyMHdvbWFufGVufDB8fHx8MTc3OTk2MTQ0Mnww&ixlib=rb-4.1.0&q=85&w=900',
  shwetaProfile: process.env.PUBLIC_URL + '/shweta22.webp',
  digvijayProfile: process.env.PUBLIC_URL + '/digvijay.webp',
  // Advisors
  advJeet: '/team/ajeet.jpeg',
  advShivam: '/shivam.webp',
  advUmang: '/team/umang1.jpg',
  advMandar: '/team/madnar-main.webp',
  advAmit: '/team/Amit-main.webp',
  advAnish: '/team/anish-main.webp',
  advNaishal: '/team/Naishal.webp',
  advOnkar: '/team/omkarsir.jpeg',
  advVijetha: '/team/vijetha.webp',

  // Initiatives
  accelerator9Mo: '/9moacc.jpeg',
  ventureStudio: '/ventstu.jpeg',

  // Partners
  partnerMsh: '/partners/msh.jpg',
  partnerIstart: '/partners/istart.jpg',
  partnerIhub: '/partners/i-hub.webp',
  partnerThub: '/partners/t-hub.webp',
  partnerJito: '/partners/jito.webp',
  partnerIim: '/partners/iim.webp',
  partnerIitj: '/partners/iitj.webp',
  partnerMit: '/partners/mit.webp',
  partnerPieds: '/partners/pieds.webp',
  partnerAic: '/partners/aic.webp',
  partnerAicJklu: '/partners/aic-jkluu.jpg',
  partnerBlal: '/partners/blal.webp',
  partnerStartupChaupal: '/partners/startupchaupal.webp',

  // Events
  eventXlr8ar1: '/events/x1.webp',
  eventXlr8ar2: '/events/x2.webp',
  eventXlr8ar3: '/events/x3.webp',
  eventXlr8ar4: '/events/x4.webp',
  eventXlr8ar5: '/events/x5.webp',
  eventXlr8ar6: '/events/x6.webp',
  eventXlr8ar8: '/events/x8.webp',
  eventXlr8ar2_1: '/events/xlr8ar2.o.JPG.webp',
  eventXlr8ar2_2: '/events/xlr8ar2.o-1.webp',
  eventXlr8ar2_3: '/events/xlr8ar2.o-2.webp',
  eventXlr8ar2_4: '/events/xlr8ar2.o/0I0A6174.webp',
  eventXlr8ar2_5: '/events/xlr8ar2.o/0I0A6274.webp',
  eventXlr8ar2_6: '/events/xlr8ar2.o/0I0A6291.webp',
  eventXlr8ar2_7: '/events/xlr8ar2.o/0I0A6407.webp',
  eventXlr8ar2_8: '/events/xlr8ar2.o/2A3A7814.webp',
  eventXlr8ar2_9: '/events/xlr8ar2.o/2A3A7893.webp',
  eventXlr8ar2_10: '/events/xlr8ar2.o/2A3A7937.webp',

  eventPs1: '/events/9 PS Accelerator series/IMG_8970.webp',
  eventPs2: '/events/9 PS Accelerator series/IMG_8978.webp',
  eventPs3: '/events/9 PS Accelerator series/IMG_9234.webp',
  eventPs4: '/events/9 PS Accelerator series/IMG_9244.webp',
  eventPs5: '/events/9 PS Accelerator series/IMG_9280.webp',
  eventPs6: '/events/9 PS Accelerator series/IMG_9376.webp',
  eventPs7: '/events/9 PS Accelerator series/IMG_9813.webp',
  eventPs8: '/events/9 PS Accelerator series/f300e062-142c-4e9c-aaea-fb50104115fa.webp',

  eventCeleb1: '/events/00001.webp',
  eventCeleb2: '/events/celebration.webp',
  eventCeleb3: '/events/2.webp',
  eventCeleb4: '/events/004.webp',
  eventCeleb5: '/events/005.webp',
  eventCeleb6: '/events/006.webp',
  eventCeleb7: '/events/007.webp',
  eventCeleb8: '/events/008.webp',

  eventVosa1: '/events/v1.webp',
  eventVosa2: '/events/v2.webp',
  eventVosa3: '/events/v3.webp',
  eventVosa4: '/events/v4.webp',

  eventD2c1: '/events/d2c/(2).webp',
  eventD2c2: '/events/d2c/(3).webp',
  eventD2c3: '/events/d2c/(4).webp',
  eventD2c4: '/events/d2c/(5).webp',
  eventD2c5: '/events/d2c/(6).webp',
  eventD2c6: '/events/d2c/(7).webp',
  eventD2c7: '/events/d2c/(8).webp',
  eventD2c8: '/events/d2c/(9).webp',

  // Team / collaboration, dark moody
  team1: '/SMQL0084.jpg.webp',
  // collab1: '/website.jpeg',
  collab1: '/about-background.webp',
  collab2: '/website-2.jpeg',
  collab3: '/website-3.jpeg',

  // Office / pitch, neon vibes
  pitch1: '/website.webp',
  pitch2: '/IMG_0877.JPG.webp',
  pitch3: '/IMG_0833.JPG.webp',
  pitch4: '/_Q9A8049.jpg.webp',

  // Sector imagery, dark editorial
  luxury1: 'https://images.unsplash.com/photo-1665224752136-4dbe2dfc8195?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkYXJrJTIwcG9ydHJhaXQlMjBidXNpbmVzcyUyMHdvbWFufGVufDB8fHx8MTc3OTk2MTQ0Mnww&ixlib=rb-4.1.0&q=85&w=940',
  luxury2: 'https://images.unsplash.com/photo-1665224751641-8ea911ca2267?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxkYXJrJTIwcG9ydHJhaXQlMjBidXNpbmVzcyUyMHdvbWFufGVufDB8fHx8MTc3OTk2MTQ0Mnww&ixlib=rb-4.1.0&q=85&w=940',
  hospitality1: 'https://images.unsplash.com/photo-1761479353103-2d4072ea5037?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxuZW9uJTIwb2ZmaWNlJTIwbmlnaHR8ZW58MHx8fHwxNzc5OTYxNDQyfDA&ixlib=rb-4.1.0&q=85&w=940',
  hospitality2: 'https://images.unsplash.com/photo-1637454699780-f6af272fc109?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxuZW9uJTIwb2ZmaWNlJTIwbmlnaHR8ZW58MHx8fHwxNzc5OTYxNDQyfDA&ixlib=rb-4.1.0&q=85&w=940',
  newtech1: 'https://images.unsplash.com/photo-1604818659463-34304eab8e70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxjeWJlcnB1bmslMjBtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzk5NjE0NDJ8MA&ixlib=rb-4.1.0&q=85&w=940',
  newtech2: 'https://images.pexels.com/photos/8108558/pexels-photo-8108558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  impact1: 'https://images.pexels.com/photos/33433724/pexels-photo-33433724.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  impact2: 'https://images.unsplash.com/photo-1515703944563-dbcfbf121b3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwb2ZmaWNlJTIwZGFya3xlbnwwfHx8fDE3Nzk5NjE0NDl8MA&ixlib=rb-4.1.0&q=85&w=940',

  // Home / About, compressed event & studio photos
  homePhotos: {
    teamGathering: '/new_images/venture-building-institution.webp',
    networkingLobby: '/Innovher-home page/2A3A5716.webp',
    meetingCandid: '/home.webp',
    msmeHonours: '/new_images/msme-honours-podium.webp',
    startupPartnership: '/new_images/startup-partnership-handshake.webp',
    innovnxtBootcamp: '/new_images/innovnxt-bootcamp.webp',
    mentorshipDiscussion: '/new_images/mentorship-table-discussion.webp',
    policeHackathon: '/new_images/police-hackathon-relevance.webp',
    credibleGovernance: '/new_images/credible-governance-team.webp',
    stageGroup: '/Innovher-home page/2A3A7338.webp',
    aiDayStage: '/Innovher-home page/ARJ79596.webp',
    aiDaySpeaker: '/Innovher-home page/ARJ79659.webp',
    exhibition: '/events/x3.webp',
    boardroomPitch: '/Innovher-home page/IMG_5117.webp',
    founderPitch: '/new_images/Copy of IMGL4119.webp',
    d2cSummit: '/new_images/bizz-expo-summit-stage.webp',
    bizzExpoStage: '/new_images/bizz-expo-summit-stage.webp',
    eventWide: '/Innovher-home page/DSC04474.webp',
    community: '/Innovher-home page/ARJ70147.webp',
  },

  // === Original Innovher imagery ===
  aboutGrid: [
    '/new_images/Copy of IMGL4119.webp',
    '/new_images/Copy of IMGL3742.webp',
    '/events/x8.webp',
    '/events/xlr8ar2.o/0I0A6291.webp',
  ],

  innovherAbout: '/stories/img1.webp',
  innovherFounder: '/stories/WhatsApp Image 2024-01-23 at 6.26.09 PM.webp',
  innovherFirstPortfolio: '/stories/innovherhosts3.webp',
  innovherMedi: '/stories/first.webp',
  innovherLaunch: '/stories/innovher1.webp',
  innovherNews: '/stories/NEWS.webp',
  // innovherServ1: 'https://innovher.com/assets/img/landing/digital-agency/services/1.png',
  // innovherServ2: 'https://innovher.com/assets/img/landing/digital-agency/services/2.png',
  // innovherServ3: 'https://innovher.com/assets/img/landing/digital-agency/services/3.png',
  // innovherServ4: 'https://innovher.com/assets/img/landing/digital-agency/services/4.png',
};

export const STOCK = {
  innovventures: '/ventstu.jpeg',
  innovace: '/9moacc.jpeg',
  innovidea: '/new_images/innovidea.webp',
  innoveda: '/Innovher-home page/IMG_5117.webp',
  encode: '/CODE/IMG_3312.webp',
  'beyond-ability-x': '/BAX/A29I2982.webp',
  'bharat-ventures': '/Bharat Ventures/RS104041.webp',
  ctpl: '/events/9 PS Accelerator series/IMG_8970.webp',
  i2i: '/website-2.jpeg',
  innovpulse: '/_Q9A8049.jpg.webp',
  innovz: '/new_images/IMG_0581.webp',
  issi: '/events/x8.webp',
  'studio-i': '/new_images/IMG_0251.webp',
  thesis: '/new_images/ai-day-startups.webp',
  build: '/new_images/Copy of IMGL4224.webp',
  portfolio: '/Innovher-home page/DSC03458.webp',
};

export const VENTURE_LOGOS = {
  encode: '/new_images/logos/encode.webp',
  beyondAbilityX: '/new_images/logos/Beyond Ability X Logo_Purple.webp',
  bharatVentures: '/new_images/logos/Bharat Ventures Black.webp',
  ctpl: '/new_images/logos/ctpl.online.webp',
  i2i: '/new_images/logos/I2I.webp',
};

export const STUDIO_IMAGES = [
  {
    id: 'studio-1',
    title: 'Executive Conference & Strategy Session',
    src: '/new_images/studio-create-conference.webp',
    tag: 'Conference',
    position: 'center center',
  },
  {
    id: 'studio-2',
    title: 'Founder Dialogue & Networking',
    src: '/new_images/studio-networking-cocktail.webp',
    tag: 'Networking',
    position: 'center 20%',
  },
  {
    id: 'studio-3',
    title: 'Founder Collaboration at Studio i',
    src: '/new_images/studio-founders-table.webp',
    tag: 'Collaboration',
    position: 'center center',
  },
  {
    id: 'studio-4',
    title: 'Studio Team & Founder Commons',
    src: '/new_images/studio-team-commons.webp',
    tag: 'Studio Team',
    position: 'center center',
  },
  {
    id: 'studio-5',
    title: 'Campus Visit at Studio i',
    src: '/new_images/IMG_0581.webp',
    tag: 'Campus Visit',
    position: 'center center',
  },
  {
    id: 'studio-6',
    title: 'Founder Conversation',
    src: '/new_images/IMG_0582.webp',
    tag: 'Conversation',
    position: 'center center',
  },
  {
    id: 'studio-7',
    title: 'Boardroom Strategy Session',
    src: '/new_images/studio-boardroom-session.webp',
    tag: 'Boardroom',
    position: 'center center',
  },
  {
    id: 'studio-8',
    title: 'Mentorship & Venture Dialogue',
    src: '/new_images/studio-mentorship-room.webp',
    tag: 'Mentorship',
    position: 'center center',
  },
  {
    id: 'studio-9',
    title: 'Studio i Atrium & Ecosystem',
    src: '/new_images/studio-atrium-banner.webp',
    tag: 'Community',
    position: 'center 25%',
  },
  {
    id: 'studio-10',
    title: 'Ecosystem Interaction & Collaboration',
    src: '/new_images/studio-ecosystem-interaction.webp',
    tag: 'Collaboration',
    position: 'center 20%',
  },
  {
    id: 'studio-11',
    title: 'Studio Lounge',
    src: '/new_images/IMG_0627.webp',
    tag: 'Lounge',
    position: 'center center',
  },
];

export const BRAND_LOGOS = [
  { name: 'Aaklan', src: '/logo/aaklan.jpg' },
  { name: 'Allure', src: '/logo/allure.jpg' },
  { name: 'Bound Fresh', src: '/logo/bound_fresh.jpg' },
  { name: 'Code Edu', src: '/logo/code_edu.jpg' },
  { name: 'Desera', src: '/logo/desera.jpg' },
  { name: 'Edinbox', src: '/logo/edinbox.jpg' },
  { name: 'Fix Papa', src: '/logo/fix_papa.jpg' },
  { name: 'Hobnob', src: '/logo/hobnob.jpg' },
  { name: 'I2I', src: '/logo/i2i(0).jpeg' },
  { name: 'Kavadea', src: '/logo/kava.jpeg' },
  { name: 'Kearn & Build', src: '/logo/kearn&build.jpg' },
  { name: 'Playgg', src: '/logo/playgg.jpg' },
  { name: 'Quicreatives', src: '/logo/quicreatives.jpg' },
  { name: 'Rahavaas', src: '/logo/rahavaas.jpg' },
  { name: 'Reee', src: '/logo/reee.webp' },
  { name: 'Reno Swift', src: '/logo/reno_swift.jpg' },
  { name: 'Saaskart', src: '/logo/saaskart.jpg' },
  { name: 'Sanchi Connect', src: '/logo/sanchi.webp' },
  { name: 'Stepwhere', src: '/logo/stepwhere.jpg' },
  { name: 'Stock Hero', src: '/logo/stock_hero.jpg' },
  { name: 'Talli Tales', src: '/logo/talli_tales.jpg' },
  { name: 'TPC', src: '/logo/tpc.jpg' },
];
